import React from "react";
import "./style.scss";

export default ({children, directonRow, isPaddingTop = true}) => {
    return (
        <div className={`page-overlay ${directonRow ? 'directon-row' : ''} ${isPaddingTop ? '-paddingTop' : ''}`}>
            {children}
        </div>
    );
}
